import { Routes } from '@angular/router';
import { canLogin } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export type LoginPageKey = 'login' | 'forgotPassword' | 'resetPassword' | 'firstAccess';

export interface LoginPageScreenConfig {
  testId: string;
  title: string;
  subtitle: string;
  submitLabel: string;
  footerLinkLabel: string;
  secondaryLink?: { label: string; route: string };
}

export const LOGIN_PAGE_CONFIG: Record<LoginPageKey, LoginPageScreenConfig> = {
  login: {
    testId: 'login-screen',
    title: 'Bem-vindo de volta',
    subtitle: 'Acesse sua conta para continuar',
    submitLabel: 'Iniciar sessão',
    footerLinkLabel: 'Esqueceu sua senha?',
    secondaryLink: { label: 'Primeiro acesso? Ativar minha conta', route: '/first-access/password' }
  },
  forgotPassword: {
    testId: 'forgot-password-screen',
    title: 'Recuperar senha',
    subtitle: 'Informe seu e-mail para receber o link de redefinição',
    submitLabel: 'Enviar link de recuperação',
    footerLinkLabel: 'Voltar para o login'
  },
  resetPassword: {
    testId: 'reset-password-screen',
    title: 'Nova senha',
    subtitle: 'Defina uma senha forte para sua conta',
    submitLabel: 'Confirmar',
    footerLinkLabel: 'Voltar para o login'
  },
  firstAccess: {
    testId: 'first-access-screen',
    title: 'Primeiro acesso',
    subtitle: 'Informe o código recebido por e-mail e defina sua senha',
    submitLabel: 'Acessar plataforma',
    footerLinkLabel: 'Voltar para o login'
  }
};

export const loginRoute: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [canLogin],
    data: {
      title: 'Login',
      fullscreen: true,
      key: PageKey.LOGIN
    }
  },
  {
    path: 'forgot/password',
    loadComponent: () => import('./pages/forgot-pwd/forgot-pwd.component').then(m => m.ForgotPwdComponent),
    canActivate: [canLogin],
    data: {
      title: 'Esqueci Senha',
      fullscreen: true
    }
  },
  {
    path: 'reset/password',
    loadComponent: () => import('./pages/reset-pwd/reset-pwd.component').then(m => m.ResetPwdComponent),
    canActivate: [canLogin],
    data: {
      title: 'Nova Senha',
      fullscreen: true
    }
  },
  {
    path: 'first-access/password',
    loadComponent: () => import('./pages/first-access/first-access.component').then(m => m.FirstAccessComponent),
    canActivate: [canLogin],
    data: {
      title: 'Primeiro acesso',
      fullscreen: true
    }
  }
];
